import { Directive, HostListener } from '@angular/core';

// taken from here: https://www.reddit.com/r/Angular2/comments/jzxi4j/how_to_disable_scrolling_on_number_inputs/
@Directive({
  selector: 'input[type="number"]',
})
export class NoScrollInputDirective {
  @HostListener('wheel', ['$event'])
  onWheel(event: Event) {
    event.preventDefault();
  }
}
